var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"popwin-overlay"},[_c('div',{staticClass:"popwin-content"},[_c('img',{staticClass:"close-btn",attrs:{"src":_vm.closeImage,"alt":""},on:{"click":function($event){return _vm.close()}}}),_c('img',{staticClass:"popwin-bg",attrs:{"src":_vm.backgroundImage,"alt":"弹窗背景"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }